import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet } from 'react-router-dom';

const RequiredSecureAuth: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();
  
  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  // Handle the case where authState is null (loading state)
  if (authState === null) {
    return (
      <div className="loading-container">
        <h3>Loading...</h3>
      </div>
    );
  }

  // If the user is authenticated, render the children routes
  if (authState.isAuthenticated) {
    return <Outlet />;
  }

  // If not authenticated (fallback)
  return (
    <div className="loading-container">
      <h3>Redirecting to login...</h3>
    </div>
  );

 

};

export default RequiredSecureAuth;
